"use client";
import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
// import "swiper/css";
// import "swiper/css/pagination";

// import "./styles.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import Link from "next/link";
import AdvertisingImage from "./AdvertisingImage";

export default function AdvertisementCarousel() {
  return (
    <div className="ad">
      <Swiper
        slidesPerView={1}
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: false,
        }}
        breakpoints={{
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        }}
        modules={[Autoplay, Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <Link href={"/course/csrG36HCVV"}>
            <AdvertisingImage
              image={"/uploads/8sin1.png"}
              styleClass={"h-[160px]"}
            />
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link href={"/course/csrVQM5UT4"}>
            <AdvertisingImage
              image={"/uploads/8sin2.png"}
              styleClass={"h-[160px]"}
            />
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link href={"/course/csrH9P34QQ"}>
            <AdvertisingImage
              image={"/uploads/8sin3.png"}
              styleClass={"h-[160px]"}
            />
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link href={"/course/csrCQ6AHJ1"}>
            <AdvertisingImage
              image={"/uploads/8sin4.png"}
              styleClass={"h-[160px]"}
            />
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link href={"/course/csr5SRC2A8"}>
            <AdvertisingImage
              image={"/uploads/8sin5.png"}
              styleClass={"h-[160px]"}
            />
          </Link>
        </SwiperSlide>
        <SwiperSlide>
          <Link href={"/course/csrX9KNNCF"}>
            <AdvertisingImage
              image={"/uploads/8sin6.png"}
              styleClass={"h-[160px]"}
            />
          </Link>
        </SwiperSlide>
      </Swiper>
    </div>
  );
}
